import { z } from 'zod';

import { PARAM_FROM, PARAM_SERIES_IDS, PARAM_TENANT_ID, PARAM_TO } from './constants';

/**
 * The filters of the placement history, which the routes that show it pick. A filter the URL
 * doesn't hold has its default.
 */
export const placementHistorySearchParams = z.object({
    // `null` is an open end, while no day is the default range
    [PARAM_FROM]: z.iso.date().nullable().optional().catch(undefined),
    [PARAM_TO]: z.iso.date().nullable().optional().catch(undefined),
    [PARAM_TENANT_ID]: z.number().optional().catch(undefined),
    // An empty list shows no series, while no list shows all of them
    [PARAM_SERIES_IDS]: z.array(z.string()).optional().catch(undefined),
});

export type PlacementHistorySearchParams = z.output<typeof placementHistorySearchParams>;

/** Removes the filters from the URL when the placement history closes */
export const noPlacementHistorySearchParams = {
    [PARAM_FROM]: undefined,
    [PARAM_TO]: undefined,
    [PARAM_TENANT_ID]: undefined,
    [PARAM_SERIES_IDS]: undefined,
} satisfies Record<keyof PlacementHistorySearchParams, undefined>;
